// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f56cc56d","389":"fa316d19","397":"057226b2","455":"1fdc207f","488":"c907732e","857":"7a11af16","977":"365c6896"}[chunkId] + ".chunk.js";
};